import React from 'react';

const Mixer = () => {
    return (
      <React.Fragment>
        <div className="btn__base r3c4">
          <div className="btn">
            <div className="fourLine">
              <div className="btn-line"></div>
              <div className="btn-line"></div>
              <div className="btn-line"></div>
              <div className="btn-line"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  export default Mixer;